import { render } from "./BaseViewHeaderMobileBtn.vue?vue&type=template&id=391bcd9d"
import script from "./BaseViewHeaderMobileBtn.vue?vue&type=script&lang=js"
export * from "./BaseViewHeaderMobileBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__